
import Vue from 'vue';
import Component from 'vue-class-component';
import EnrollmentBase from '@/login/components/EnrollmentBase/EnrollmentBase.vue';
import { CodeValidation, ConfirmValidation } from '@kasasa/kloans-common-ui/dist/validations';
import { AxiosPromise } from 'axios';
import { postCreatePin } from '@kasasa/kloans-common-ui/dist/consumer-app/services/kloans-authentication';
import { getModule } from 'vuex-module-decorators';
import LoginStore from '@/login/store';
import { store } from '@/store';

getModule(LoginStore, store);

@Component({
	validations: {
		pin: CodeValidation.validations(4),
		pin1: ConfirmValidation.validations('pin'),
	},
	components: {
		EnrollmentBase,
	},
})
export default class PinSetup extends Vue {
	pin: string = '';

	pin1: string = '';

	formTemplate: string = 'pinSetup';

	instructions: string = 'If we ever need additional verification, we will use a unique, 4-digit support code to help identify you.';

	formErrorMessage: string = '';

	submitBtn: boolean = true;

	token: string = '';

	last4Ssn: string = '';

	dateOfBirth: string = '';

	sessionExpired: boolean = false;

	timeoutState: string = 'enabled';

	created() {
		this.token = sessionStorage.getItem('token') || '';
		this.last4Ssn = sessionStorage.getItem('last4Ssn') || '';
		this.dateOfBirth = sessionStorage.getItem('dateOfBirth') || '';
	}

	get pinErrors() {
		return CodeValidation.errors(this, 'pin', '4', 'Pin');
	}

	get pin1Errors() {
		return ConfirmValidation.errors(this, 'pin1', 'pin');
	}

	async submitPin() {
		this.$v.$touch();
		if (!this.$v.$invalid) {
			this.submitBtn = false;
			try {
				await (postCreatePin({
					pin: this.pin,
					pinConfirmation: this.pin1,
					token: this.token,
					ssnLast4: this.last4Ssn,
					dateOfBirth: this.dateOfBirth,
				}) as AxiosPromise<string>);
				this.formErrorMessage = '';
				this.timeoutState = 'disabled';
				this.$router.push({ name: 'enrollmentComplete' });
			} catch (error) {
				let message = 'An unknown error has occurred.';
				if ((error as any).response.error && (error as any).response.error.message) {
					message = (error as any).response.error.message;
				}
				this.formErrorMessage = message;
			} finally {
				this.submitBtn = true;
			}
		}
	}
}
